export default {
  heading: 'Business Consulting services',
  collection: [
    {
      image: {
        filename:
          '//a.storyblok.com/f/46530/150x150/2265fd511b/icon-v4_icon-diagnostic.svg',
      },
      heading: 'Total Experience Diagnostic',
    },
    {
      image: {
        filename:
          '//a.storyblok.com/f/46530/150x150/2265fd511b/icon-v4_icon-diagnostic.svg',
      },
      heading: 'Total Experience Diagnostic',
    },
    {
      image: {
        filename:
          '//a.storyblok.com/f/46530/150x150/2265fd511b/icon-v4_icon-diagnostic.svg',
      },
      heading: 'Total Experience Diagnostic',
    },
  ],
  component: 'o-features',
}
